import React, { useState, useEffect } from "react";
import { Redirect } from "react-router-dom";

// @material-ui/core
import { makeStyles } from "@mui/styles";

import { ArrowRightAlt } from "@mui/icons-material";
import { Grid } from "@mui/material";

import BarChartCompanyCitiesAdmin from "views/Graphs/BarChartCompanyCitiesAdmin";
import PieChartUsersTypesAdmin from "views/Graphs/PieChartUsersTypesAdmin";

import {
  dashboardStyle,
  ButtonStyleWhite0,
} from "assets/jss/material-dashboard-react/views/dashboardStyle.js";

const useStyles = makeStyles(dashboardStyle);

export default function Dashboard() {
  const classes = useStyles();

  const [buttonUsers, setUsers] = useState(false);
  const [buttonCompanies, setCompanies] = useState(false);

  useEffect(() => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  }, []);

  const handleUsers = () => () => {
    setUsers(true);
  };

  const handleCompanies = () => () => {
    setCompanies(true);
  };

  if (buttonUsers) {
    return <Redirect to="/superadmin/users" />;
  }

  if (buttonCompanies) {
    return <Redirect to="/superadmin/companies" />;
  }

  return (
    <div>
      <Grid container>
        <Grid item xs={12} md={12}>
          <div className={classes.carDashboard}>
            <Grid
              container
              spacing={4}
              sx={{
                padding: "30px 0",
              }}
            >
              <Grid item xs={12} sm={12}>
                <b style={{ color: "#202C59", fontSize: 32, marginLeft: 10 }}>
                  Bienvenid@ administrador
                </b>
              </Grid>
              <Grid
                item
                xs={12}
                sm={5}
                sx={{
                  border: "1px solid #e9ebee",
                  m: "30px 10px 10px 60px",
                  p: 2,
                }}
              >
                <BarChartCompanyCitiesAdmin />
              </Grid>
              <Grid
                item
                xs={12}
                sm={6}
                sx={{
                  border: "1px solid #e9ebee",
                  m: "30px 0 10px 1px",
                  p: 2,
                }}
              >
                <PieChartUsersTypesAdmin />
              </Grid>
              <Grid
                item
                xs={12}
                sm={6}
                sx={{
                  display: "flex",
                  flexDirection: "column",
                  alignItems: "center",
                  justifyContent: "center",
                }}
              >
                <ButtonStyleWhite0
                  style={{ fontSize: 16, width: 230 }}
                  onClick={handleCompanies()}
                  endIcon={<ArrowRightAlt />}
                >
                  Módulo de empresas
                </ButtonStyleWhite0>
              </Grid>
              <Grid
                item
                xs={12}
                sm={6}
                sx={{
                  display: "flex",
                  flexDirection: "column",
                  alignItems: "center",
                  justifyContent: "center",
                }}
              >
                <ButtonStyleWhite0
                  style={{ fontSize: 16, width: 230 }}
                  onClick={handleUsers()}
                  endIcon={<ArrowRightAlt />}
                >
                  Módulo de usuarios
                </ButtonStyleWhite0>
              </Grid>
            </Grid>
          </div>
        </Grid>
      </Grid>
    </div>
  );
}
